package com.example.mystybag.core.model

data class CityItem(
    val id: Long,
    val name: String,
    val countryId: Int = 0,
    val latitude: Double = 0.0,
    val longitude: Double = 0.0
)

